export default function LearningSection({ onOpenModal }: { onOpenModal: () => void }) {
  const learningPoints = [
    {
      title: 'El Secreto de la IA → La Fábrica de Activos 🏗️',
      description: 'De Cero a Producto en 24h: El método exacto para fabricar Ebooks, Plantillas y Tools de alta demanda sin escribir una sola palabra.'
    },
    {
      title: 'Venta Local → Cero Complicaciones, Soles en Mano 💰',
      description: 'Dominio del Mercado Local: Olvídate del dólar y las pasarelas gringas. Aprende a recibir pagos directo en tu cuenta bancaria (Soles, Pesos) hoy mismo'
    },
    {
      title: 'Rentabilidad Extrema → El 90% es Tuyo 📈',
      description: 'Margen de Ganancia del 90%: Cómo saltarte a los intermediarios y plataformas que te quitan la mitad de tu esfuerzo. Si tú creas el valor, tú te llevas el dinero'
    },
    {
      title: 'Sistema de Ventas → Máquina de Ventas en Piloto Automático 🤖',
      description: 'Tu Vendedor 24/7: La hoja de ruta para automatizar la captación y el cierre. Cómo vender mientras duermes, viajas o sigues creando tu próximo producto'
    }
  ];

  return (
    <section className="py-14 sm:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-16">
          <h2 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-4 leading-tight px-2">
            ¿QUÉ VAS A APRENDER EN ESTA CLASE?
          </h2>
          <div className="w-16 sm:w-20 h-1 bg-emerald-600 mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-8 mb-8 sm:mb-14">
          {learningPoints.map((point, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-2xl sm:rounded-3xl p-4 sm:p-8 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-green-500 rounded-full flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-base sm:text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-base sm:text-xl font-bold text-gray-900 mb-1 sm:mb-2 leading-snug">
                    {point.title}
                  </h3>
                  <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                    {point.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-red-600 to-red-700 rounded-2xl sm:rounded-3xl p-4 sm:p-8 mb-8 sm:mb-14 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-red-500">
          <div className="flex items-start gap-3 sm:gap-4">
            <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-white rounded-full flex-shrink-0 mt-0.5">
              <i className="ri-vip-crown-2-fill text-base sm:text-xl text-red-600"></i>
            </div>
            <div>
              <h3 className="text-base sm:text-xl font-bold text-white mb-1 sm:mb-2">
                Comunidad Exclusiva 🔥
              </h3>
              <p className="text-sm sm:text-base text-red-100 leading-relaxed">
                No estarás solo en el camino. Únete a nuestra comunidad privada donde compartimos{' '}
                <strong className="text-yellow-300 font-bold">lo que está facturando HOY mismo</strong>, actualizaciones de IA para que no quedes obsoleto y el soporte que necesitas para que tu primera venta llegue en tiempo récord.
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-center px-4">
          <button
            onClick={onOpenModal}
            className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-3 bg-black text-white px-6 py-4 rounded-full text-sm sm:text-base font-semibold uppercase border-2 border-emerald-500 hover:bg-emerald-600 hover:border-emerald-600 transition-all duration-300 cursor-pointer w-full sm:w-auto leading-snug"
          >
            <span className="whitespace-nowrap">👉 SÍ, QUIERO MI FÁBRICA</span>
            <span className="whitespace-nowrap">DE PRODUCTOS DIGITALES</span>
          </button>
        </div>
      </div>
    </section>
  );
}
